<template>
  <div>
    <highcharts :key="hcKey" :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { setChartMenuItemsLang } from '../../../utils/formatter'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    xAxisTitle: {
      type: String,
      required: true,
    },
    yAxisTitle: {
      type: String,
      required: true,
    },
    whenMopVisualize: {
      type: String,
      required: true,
    },
    animation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hcKey: 0,
    }
  },

  computed: {
    chartOptions: function () {
      const vueThis = this
      return {
        lang: this.setOptions,
        boost: {
          seriesThreshold: 2,
          usePreAllocated: true,
        },
        chart: {
          height: '50%',
          zoomType: 'xy',
          margin: [50, 20, 50, 80],
          backgroundColor: '#FFFFFF',
          animation: vueThis.animation,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        title: {
          text: this.title,
          style: { fontSize: '25px', fontWeight: 'bold' },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              '<b class="hc-tooltip-title">' +
              this.point.meta.name +
              '</b><br>' +
              '<b>' +
              this.point.meta.issuerName +
              '</b>'
            )
          },
        },
        xAxis: {
          title: {
            text: this.xAxisTitle,
          },
          allowDecimals: true,
          showLastLabel: true,
          endOnTick: true,
        },
        yAxis: {
          title: {
            text: this.yAxisTitle,
          },
          allowDecimals: true,
          showLastLabel: true,
          endOnTick: true,
        },
        series: [
          {
            type: 'line',
            name: 'Regression Line',
            color: getComputedStyle(document.documentElement).getPropertyValue('--primary'),
            data: this.lineSeries,
            marker: {
              enabled: false,
            },
            states: {
              hover: {
                lineWidth: 0,
              },
            },
            enableMouseTracking: false,
          },
          {
            type: 'scatter',
            name: 'Scenarios/Costs',
            data: this.dataSeries,
            marker: {
              radius: 4,
            },
          },
        ],
      }
    },

    dataSeries: function () {
      let out = []
      if (!this.value || Object.keys(this.value).length === 0) return out

      let costsValues = this.value['x'].map((el) => el[this.whenMopVisualize])
      let scenariosValues = this.value['y'].map((el) => el[this.whenMopVisualize])

      if (costsValues.length !== scenariosValues.length) return out

      let values = []
      for (let i = 0; i < costsValues.length; i++) {
        values[0] = costsValues[i]
        values[1] = scenariosValues[i]

        out.push({
          x: costsValues[i],
          y: scenariosValues[i],
          meta: { ...this.value['x'][i].productKey },
        })
      }

      return out
    },

    lineSeries: function () {
      let out = []
      const str = this.whenMopVisualize.toString()
      const whenMopVisualize = str.charAt(0).toUpperCase() + str.slice(1)
      const key = 'line' + whenMopVisualize

      if (!key in this.value || !this.value[key]) return out
      const points = Object.values(this.value[key])

      points.forEach((el) => {
        out.push([el.x, el.y])
      })

      return out
    },

    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
}
</script>

<style lang="scss" scoped></style>
